import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import LoadingState from '../shared/LoadingState';
import EmptyState from '../shared/EmptyState';
import '../superadmin/DistrictsList.css';

const MyStudentsList = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  useEffect(() => {
    fetchStudents();
  }, []);

  const fetchStudents = async () => {
    try {
      const response = await axios.get('/api/students/my-students');
      setStudents(response.data);
    } catch (error) {
      console.error('Failed to fetch students:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`/api/students/my-students/${id}`);
      setStudents(students.filter(s => s.id !== id));
      setDeleteConfirm(null);
      alert(`✅ SUCCESS: ${response.data.message}`);
    } catch (error) {
      console.error('Failed to delete student:', error);
      alert(`❌ FAILED: Could not delete student. Check console for details.`);
    }
  };

  if (loading) {
    return <LoadingState message="Loading students..." fullScreen />;
  }

  return (
    <div className="districts-list">
      <div className="page-header">
        <h2>My Students</h2>
        <Link to="/parent/new-student" className="btn-primary">Add a New Student</Link>
      </div>

      {deleteConfirm && (
        <div className="modal-overlay" onClick={() => setDeleteConfirm(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h3>Delete Student</h3>
            <p>Are you sure you want to delete this student's information? This action cannot be undone.</p>
            <div className="modal-actions">
              <button onClick={() => handleDelete(deleteConfirm)} className="btn-danger">Delete</button>
              <button onClick={() => setDeleteConfirm(null)} className="btn-secondary">Cancel</button>
            </div>
          </div>
        </div>
      )}

      {students.length === 0 ? (
        <EmptyState
          icon="👥"
          title="No Students Yet"
          message="Add your first student to get started. You can manage multiple students from this page."
          action={<Link to="/parent/new-student" className="btn-primary">Add a New Student</Link>}
        />
      ) : (
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th>Name (Last, First)</th>
                <th>Age</th>
                <th>Grade</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {students.map(student => (
                <tr key={student?.id}>
                  <td>{student?.last_name || ''}, {student?.first_name || ''}</td>
                  <td>{student?.age || '-'}</td>
                  <td>{student?.grade || '-'}</td>
                  <td className="actions">
                    <Link to={`/parent/students/edit/${student?.id}`} className="btn-edit">Edit</Link>
                    <button onClick={() => setDeleteConfirm(student?.id)} className="btn-delete">Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default MyStudentsList;




